import { PRIORITY_CONFIG } from '../utils/priorityConfig';
import { useTranslation } from 'react-i18next';

interface PriorityPillProps {
  priority: string;
  size?: 'sm' | 'md';
}

export const PriorityPill = ({ priority, size = 'md' }: PriorityPillProps) => {
  const { t } = useTranslation('analysis');
  const config = PRIORITY_CONFIG[priority.toLowerCase()] ?? PRIORITY_CONFIG.low;
  const Icon = config.icon;
  const isSmall = size === 'sm';

  return (
    <div
      className={`inline-flex w-fit items-center gap-0.5 rounded-full px-3 ${
        isSmall ? 'py-0.5' : 'py-1'
      } ${config.pillBg} ${config.textColor}`}
    >
      <Icon className={isSmall ? 'size-4' : 'size-5'} />
      <span className={`font-medium ${isSmall ? 'text-body-sm' : 'text-body-md'}`}>
        {t('analysisResult.priorityPill.priorityLabel', {
          priority: priority.charAt(0).toUpperCase() + priority.slice(1),
        })}
      </span>
    </div>
  );
};
